import { useNavigate } from "@tanstack/react-router";
import { useAtom } from "jotai";
import { useCallback } from "react";
import { setStudyGroupAtom } from "@/stores/studyGroupAtoms";

/**
 * スタディグループのナビゲーションを処理するカスタムフック
 * スタディグループの情報を更新し、対応するストリームページに遷移します
 */
export const useStudyGroupNavigation = () => {
  const navigate = useNavigate();
  const [, setStudyGroup] = useAtom(setStudyGroupAtom);

  const navigateToStudyGroup = useCallback(
    (
      containerId: number,
      studyGroupId: number,
      guid: string,
      name: string,
      imageUrl: string,
      joinPolicy?: number,
    ) => {
      setStudyGroup({
        containerId,
        studyGroupId,
        guid,
        name,
        imageUrl,
        data: null, // 後でfetchStudyGroupで完全なデータに更新される
        join_policy: joinPolicy ?? 0,
      });

      requestAnimationFrame(() => {
        try {
          navigate({
            to: "/study-group/$study-group-id/stream",
            params: { "study-group-id": String(studyGroupId) },
            replace: false,
          });
        } catch (error) {
          console.error("❌ Navigation error:", error);
        }
      });
    },
    [navigate, setStudyGroup],
  );

  return { navigateToStudyGroup };
};
